import { render, staticRenderFns } from "./btmeterdata.vue?vue&type=template&id=22650df2&"
import script from "./btmeterdata.vue?vue&type=script&lang=js&"
export * from "./btmeterdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports